import { render, staticRenderFns } from "./homeDownload.vue?vue&type=template&id=0af1c555&scoped=true&"
import script from "./homeDownload.vue?vue&type=script&lang=ts&"
export * from "./homeDownload.vue?vue&type=script&lang=ts&"
import style0 from "./homeDownload.vue?vue&type=style&index=0&id=0af1c555&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1c555",
  null
  
)

export default component.exports